function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import FullParagraph from "segments/desktop/core-components/full-paragraph/full-paragraph";
import BoardViewsTab from "segments/desktop/core-components/board-views-tab/board-views-tab";
import { StyledSideBySideBoardViewsComponentTabsDesktopComponent } from "./side-by-side-board-views-component-tabs-desktop-component.scss";
const SideBySideBoardViewsComponentTabsDesktopComponent = (props)=>{
    const { fullParagraph, theme, tabs } = props;
    return /*#__PURE__*/ _jsxs(StyledSideBySideBoardViewsComponentTabsDesktopComponent, {
        className: "side-by-side-board-views-component-tabs-component",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "full-paragraph-wrapper",
                children: /*#__PURE__*/ _jsx(FullParagraph, _object_spread({}, fullParagraph))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "board-views-tab-wrapper",
                children: /*#__PURE__*/ _jsx(BoardViewsTab, {
                    theme: theme,
                    tabs: tabs
                })
            })
        ]
    });
};
export default SideBySideBoardViewsComponentTabsDesktopComponent;
